
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from './controlador';
    import { Utiles } from '@/__env/pluggins/event-bus';
    import { Categoria } from '@/__env/lib/Web/Categorias';
    @Component( {
        name: "Componente",
        props: {},
        components: {

        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorSeccion;
        public get Buscador() { return this.Controlador.Buscador; }
        public get Filtrados() { return this.Controlador.Filtrados; }

        @Prop()
        public Item: Categoria;

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }
        mounted()
        {

        }

        public async Abrir()
        {
            if ( this.Controlador.Seleccionado )
                this.Controlador.Historial.push( this.Controlador.Seleccionado );

            this.Controlador.Seleccionado = this.Item;
            this.Buscador.Filtros.Padre = this.Item.Id;
            this.Filtrados.clear();
            await this.Buscador.Buscar();

        }

        public async Eliminar()
        {
            if ( await Utiles.Mensajes.SiNo( '�Eliminar esta categor�a?', 'Se eliminar�n tambien todas sus subcategorias' ) )
            {
                if ( await this.Item.del() )
                {
                    let idx = this.Buscador.Items.findIndex( x => x.Id == this.Item.Id );
                    this.Buscador.Items.splice( idx, 1 );
                    Utiles.Notificaciones.Completado( 'Eliminada!' );
                }
                else
                {
                Utiles.Notificaciones.Error( 'Error al eliminada' );
                }
            }
        }

        public async Actualizar()
        {
            if ( this.Item.DescripcionNueva && this.Item.DescripcionNueva.length >= 3 && this.Item.DescripcionNueva != this.Item.Descripcion )
            {
                this.Item.Descripcion = this.Item.DescripcionNueva;


                if ( await this.Item.save() )
                {
                    Utiles.Notificaciones.Completado( 'Actualizada!' );
                    this.Item.DescripcionNueva = this.Item.Descripcion;
                }
                else
                {
                    Utiles.Notificaciones.Error( 'Error al guardar' );
                }



            }
        }

    }
